const borderLightColor = '#eeeeee';
const lightColor = '#949594';
const darkColor = '#444444';


export const reportStyles = {
  pageMargins: [50, 25, 50, 25],

  headStyles: {
    // font: 'Font',
    fontSize: 9,
    fontStyle: 'normal',
    valign: 'middle',
    fillColor: hex2rgbArr(darkColor),
    textColor: 255,
    textTransform: 'uppercase',
  },

  bodyStyles: {
    // font: 'Font',
    overflow: 'linebreak',
    textColor: 0
  },

  header: {
    textColor: lightColor,
  },

  footer: {
    textColor: lightColor,
  },

  // Striped table
  rowOdd: {
    fillColor: [245, 245, 245]
  },

  // Special table rows for grouping
  h1: {
    fontStyle: 'bold',
    fillColor: hex2rgbArr(lightColor),
    textColor: [255, 255, 255]
  },
  h2: {
    fontStyle: 'bold',
    textColor: hex2rgbArr(darkColor),
    borderWidth: 1,
    borderColor: hex2rgbArr(darkColor)
  },
  h3: {
    fontStyle: 'bold'
  }
};

/**
 * Converts #rgb color string to array: '#0a0b0c' -> [10, 11, 12]
 */
function hex2rgbArr(rgb) {
  if ((typeof rgb === 'string') && /^#[0-9A-Fa-f]{6}$/.test(rgb)) {
    const hex = parseInt(rgb.substr(1), 16);
    return [(hex >> 16) & 255, (hex >> 8) & 255, (hex & 255)];
  }
  return rgb;
}
